import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import DoneIcon from '@mui/icons-material/Done';
import { useTheme } from '@mui/material/styles';

import CaseAccordion from './CaseAccordion';
import { userRoles } from '../../../../constants';

const CompletedCase = ({ onClose, activeCase, surgeons }) => {
  const theme = useTheme();

  const { surgeon } = activeCase;

  const caseSurgeon = useMemo(
    () => surgeons.find((user) => user.uid === surgeon?.id || user.uid === surgeon?.userId),
    [surgeons, surgeon?.id, surgeon?.userId]
  );
  const caseSurgeonName = `${caseSurgeon?.firstName || ''} ${caseSurgeon?.lastName || ''}`.trim();

  return (
    <div className="case-step-container">
      <div className="case-step-content">
        <div className="case-step-row">
          <div className="column">
            <DoneIcon color="primary" />
          </div>
          <div className="modal-item-content">
            <div className="font-size-bg">
              Case has been completed by
              <span style={{ color: theme.palette.primary.main }}>
                {caseSurgeonName ? ` Dr. ${caseSurgeonName}` : ' '}
              </span>
              <span className="secondary">
                {' '}
                – {moment(activeCase?.completionDates?.step11).format('DD/MM/YYYY')}
              </span>
            </div>
          </div>
        </div>
        <CaseAccordion currentStep={12} />
      </div>
      <div className="case-modal-actions">
        <div className="secondary pointer" onClick={onClose}>
          Close
        </div>
      </div>
    </div>
  );
};

CompletedCase.propTypes = {
  activeCase: PropTypes.object,
  onClose: PropTypes.func,
};

const mapStateToProps = (state) => {
  const activeCase = state.cases.activeCase;

  return {
    activeCase,
    surgeons: state.users.list.filter((user) => user.role === userRoles.SURGEON.name),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CompletedCase);
